import store from '../store';

export const setExclusive = (params) => {
    const tabId = store.getState().menu.submenu.id;
    return {
        ...params,
        exclusive: true,
        currentTab : tabId
    }
}